export default __webpack_public_path__ + "static/media/room-3Bed-double.bd92b32b.jpg";